import React, { useState, useEffect } from "react";
import {useDrag} from "react-dnd";
import {ItemTypes} from "../team-page/itemTypes.js";
import {findObjectByKeyValue} from "../utils.js";
import {Link} from "react-router-dom";
import {Popup} from "../common/Popup.jsx";
import notifications from "../../json-data/notifications.json";


function Chat({messages, showChat, setShowChat}) {

    console.log(showChat);

    const [activeChatId, setActiveChatId] = useState(null);
    const [chatOpen, setChatOpen] = React.useState(false);

    useEffect(() => {
        if (Array.isArray(messages) && messages.length > 0 && activeChatId === null) {
            setActiveChatId(messages[0].id);
        }
    }, [messages, activeChatId]);

    const activeChat = activeChatId 
        ? findObjectByKeyValue(messages || [], 'id', activeChatId)
        : null;

    function countNewMessages(data) {
        let count = 0;
        console.log('[Chat countNewMessages] Trying loop. typeof data:', typeof data, ' | Is Array:', Array.isArray(data));
        if (Array.isArray(data)) {
            data.forEach(item => {
                if (item && Array.isArray(item.messages)) {
                    count += countNewChatMessages(item);
                }
            });
        }
        return count;
    }

    function countNewChatMessages(data) {
        let count = 0;
        const messagesForLog = data ? data.messages : undefined;
        console.log('[Chat countNewChatMessages] Trying loop. typeof data.messages:', typeof messagesForLog, ' | Is Array:', Array.isArray(messagesForLog));
        if (data && Array.isArray(data.messages)) {
            data.messages.forEach(message => {
                if (message && message.statusNew) {
                    count++;
                }
            });
        }
        return count;
    }

    const formatDate = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        if (date.toDateString() === today.toDateString()) {
            return `${hours}:${minutes}`;
        } else if (date.toDateString() === yesterday.toDateString()) {
            return "Yesterday";
        } else {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            return `${day}.${month}.${year}`;
        }
    };

    console.log('[Chat main body] Trying map. typeof messages:', typeof messages, ' | Is Array:', Array.isArray(messages));
    const Chats = (messages || []).map((item, index) => {
        const lastMessage = (item && Array.isArray(item.messages) && item.messages.length > 0) ? item.messages[item.messages.length - 1] : null;
        const messageTime = lastMessage ? formatDate(lastMessage.time) : '';
        const messageText = lastMessage ? lastMessage.message : '';
        const newMessageCount = countNewChatMessages(item);

        return (
            <li key={index}>
                <button
                    className="contact-container open_chat_body_btn"
                    onClick={() => { if(item && item.id) { setActiveChatId(item.id); setChatOpen(true); } }}
                >
                    <div className="image-col">
                        {item?.image && <img src={item.image} alt={item?.title || 'Chat'} />}
                    </div>
                    <div className="content-col">
                        <div className="flex-block title-block">
                            <h4>
                                {item?.title || 'Unknown Chat'}
                            </h4>
                            <div className="info-block">
                                {newMessageCount > 0 && <div className="count">{newMessageCount}</div>}
                                <div className="time">
                                    {messageTime}
                                </div>
                            </div>
                        </div>
                        <div className="messages-block">
                            <div className="message">
                                {messageText}
                            </div>
                        </div>
                    </div>
                </button>
            </li>
        );
    });

    const ChatMessages = (chat) => {
        const chatMessagesForLog = chat ? chat.messages : undefined;
        console.log('[Chat ChatMessages func] Trying reduce. typeof chat.messages:', typeof chatMessagesForLog, ' | Is Array:', Array.isArray(chatMessagesForLog));
        if (!chat || !Array.isArray(chat.messages) || chat.messages.length === 0) {
            return null;
        }

        const formatDate = (timestamp) => {
            const date = new Date(timestamp * 1000);
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);

            if (date.toDateString() === today.toDateString()) {
                return 'Today';
            } else if (date.toDateString() === yesterday.toDateString()) {
                return 'Yesterday';
            } else {
                return date.toLocaleDateString('en-US', { day: 'numeric', month: 'long' });
            }
        };

        const formatTime = (timestamp) => {
            const date = new Date(timestamp * 1000);
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        };

        const groupedMessages = chat.messages.reduce((acc, message) => {
            const messageDate = new Date(message.time * 1000).toDateString();
            if (!acc[messageDate]) {
                acc[messageDate] = [];
            }
            acc[messageDate].push(message);
            return acc;
        }, {});

        return (
            <div>
                {Object.keys(groupedMessages).map((dateKey) => {
                    const messagesOnDate = groupedMessages[dateKey];
                    const displayDate = formatDate(messagesOnDate[0].time);

                    const senderGroups = messagesOnDate.reduce((acc, message) => {
                        if (!acc[message.sender]) {
                            acc[message.sender] = [];
                        }
                        acc[message.sender].push(message);
                        return acc;
                    }, {});

                    return (
                        <div key={dateKey}>
                            <div className="day-row">
                                <div className="day">{displayDate}</div>
                            </div>
                            {Object.keys(senderGroups).map((sender) => {
                                const senderImage = senderGroups[sender][0].image;

                                return (
                                    <div key={sender} className="contact-container">
                                        <div className="image-col">
                                            <img src={senderImage} alt={sender} />
                                        </div>
                                        <div className="content-col">
                                            <div className="title-block">
                                                <h4>
                                                    {sender}:
                                                </h4>
                                            </div>
                                            {senderGroups[sender].map((msg, index) => (
                                                <div key={index} className="flex-block messages-block">
                                                    <div className="message">
                                                        {msg.message}
                                                    </div>
                                                    <div className="time">
                                                        {formatTime(msg.time)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    };

    const renderChatMessages = activeChat ? ChatMessages(activeChat) : <div className="no-chat-selected">Select a chat to view messages.</div>;

    return (
        <div className={`chat-popup popup ${showChat ? 'active' : ''}`}>
            <button className="pop-close icon-s-cross"
                    onClick={() => {setShowChat(false)}}
            />
            <div id="chat_pop_content" className="pop-content chat-pop-content">
                <div id="chat_container">
                    <div className="chat-grid">
                        <div className="left-col">
                            <div className="chat-header">
                                <div className="title">
                                    <button className="close_chat ico icon-chev-right"
                                            onClick={() => {setShowChat(false)}}
                                    />
                                    <h2>
                                        MESSENGER
                                    </h2>
                                </div>
                                <div className="count">
                                    {countNewMessages(messages)}
                                </div>
                            </div>

                            <div className="main-block">
                                <div className="frame">
                                    <ul className="contacts-list">
                                        {Chats}
                                    </ul>
                                </div>
                            </div>

                            <div className="footer-block">
                                <form action="#">
                                    <div className="search-form-block">
                                        <input type="text" placeholder="Search" />
                                        <button type="submit" className="ico icon-search" />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className={`right-col chat_col ${chatOpen ? 'active' : ''}`}>
                            <div id="chat_body_container">
                                <div className="chat-header">
                                    <div className="title">
                                        <button className="close_chat ico icon-chev-right close_chat_body_btn"
                                                onClick={() => {setChatOpen(false)}}
                                        />
                                        <h2>
                                            {activeChat?.title || 'Unknown Chat'}
                                        </h2>
                                    </div>
                                    <div className="info">
                                        {activeChat?.members} members
                                        <div className="ico icon-tip" />
                                    </div>
                                </div>
                                <div className="main-block">
                                    <div id="chat_body">
                                        <div className="frame">
                                            {renderChatMessages}
                                        </div>
                                    </div>
                                </div>
                                <div className="footer-block">
                                    <form action="#">
                                        <div className="ctrls-form-block">
                                            <div className="textarea-group">
                                                <textarea name="" id="" placeholder="Write a message..." />
                                            </div>
                                            <div className="ctrls-block">
                                                <div className="form-group">
                                                    <button className="ico icon-hexagon" />
                                                </div>
                                                <div className="form-group">
                                                    <input type="file" id="chat_file" />
                                                    <label htmlFor="chat_file" className="ico icon-file" />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="ico icon-send" />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export {Chat}
